import { Core4Metric } from '../../../model/Entities';

/** HITTING **/

export const softballCore4MetricExitVelocity: Core4Metric = {
    code: 'RSHEXITSPEED',
    categoryCode: 'HITTING',
    sportCode: 'SOFTBALL',
    name: 'Exit Velocity',
    best: 'max',
    comparable: true,
};

export const softballCore4MetricBatSpeed: Core4Metric = {
    code: 'BATSPEED',
    categoryCode: 'HITTING',
    sportCode: 'SOFTBALL',
    name: 'Bat Speed',
    best: 'max',
    comparable: true,
};

export const softballCore4MetricPeakHandSpeed: Core4Metric = {
    code: 'PEAKHANDSPEED',
    categoryCode: 'HITTING',
    sportCode: 'SOFTBALL',
    name: 'Peak Hand Speed',
    best: 'max',
    comparable: true,
};

export const softballCore4MetricTimeToContact: Core4Metric = {
    code: 'TIMETOCONTACT',
    categoryCode: 'HITTING',
    sportCode: 'SOFTBALL',
    name: 'Time to Contact',
    best: 'min',
    comparable: true,
};

/** ARM VELOCITY **/

export const softballCore4MetricPositionThrowVelocity: Core4Metric = {
    code: 'POSTHROWVEL',
    categoryCode: 'ARMVELOCITY',
    sportCode: 'SOFTBALL',
    name: 'Position Throwing Velocity',
    best: 'max',
    comparable: true,
};

/** SPEED & AGILITY **/

export const softballCore4Metric10YD: Core4Metric = {
    code: '10YD',
    categoryCode: 'SPEEDAGILITY',
    sportCode: 'SOFTBALL',
    name: '10 Yard Dash',
    best: 'min',
    comparable: true,
};

export const softballCore4Metric20YD: Core4Metric = {
    code: '20YD',
    categoryCode: 'SPEEDAGILITY',
    sportCode: 'SOFTBALL',
    name: '20 Yard Dash',
    best: 'min',
    comparable: true,
};

export const softballCore4Metric5105: Core4Metric = {
    code: '5105',
    categoryCode: 'SPEEDAGILITY',
    sportCode: 'SOFTBALL',
    name: '5-10-5',
    best: 'min',
    comparable: true,
};

/** STRENGTH **/

export const softballCore4MetricVerticalJump: Core4Metric = {
    code: 'VERTICALJUMP',
    categoryCode: 'STRENGTH',
    sportCode: 'SOFTBALL',
    name: 'Vertical Jump',
    best: 'max',
    comparable: true,
};

export const softballCore4MetricHandGripRT: Core4Metric = {
    code: 'HANDGRIPRT',
    categoryCode: 'STRENGTH',
    sportCode: 'SOFTBALL',
    name: 'Hand Grip Strength (RT)',
    best: 'max',
    comparable: true,
};

export const softballCore4MetricHandGripLT: Core4Metric = {
    code: 'HANDGRIPLT',
    categoryCode: 'STRENGTH',
    sportCode: 'SOFTBALL',
    name: 'Hand Grip Strength (LT)',
    best: 'max',
    comparable: true,
};
